import {
  COMMANDE_CREER_SUCCES,
  COMMANDE_CREER_ECHEC,
  COMMANDE_LISTE_CLI_SUCCES,
  COMMANDE_LISTE_CLI_ECHEC,
  COMMANDE_DETAILS_ECHEC,
  COMMANDE_DETAILS_SUCCES,
  COMMANDE_DETAILS_REQUETTE,
  COMMANDE_LISTE_CODE_SUCCES,
  COMMANDE_LISTE_CODE_ECHEC,
  COMMANDE_LISTE_REP_SUCCES,
  COMMANDE_LISTE_REP_ECHEC,
  COMMANDE_TOUS_SUCCES,
  COMMANDE_TOUS_ECHEC,
  COMMANDE_TOUS_REQUETTE,
  COMMANDE_LISTE_REP_REQUETTE,
  VENTE_RAPPORT_REQUETTE,
  VENTE_RAPPORT_SUCCES,
  VENTE_RAPPORT_ECHEC,
} from "../constantes/commandeConstantes";
import axios from "axios";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;
//const uri = `https://ecreal.herokuapp.com`;
//const uri = `https://ecreal.onrender.com`;
//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = "http://localhost:5000";
//const uri = `http://192.168.1.19:5000`;
//const uri = `https://gestpro.globalsystempro.com/back`;
import { store } from "../store";
import { CHARIOT_RESET } from "../constantes/chariotConstantes";

let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();

export const creerCommande = (commande) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };

    // axios c'est le client http qui nous permet de faire des requetes http vers le serveur,post c'est le type de requet http,
    //la requet post ou put elle prend comme parametre ladresse! `${uri}/api/commandes` ,le body qui contient les données pour le traitement
    //dans notre cas le body est l'objet commande qui contient les information de commande a inserer comme cod_cli,cod_rep,adrees,montat commande....
    //et finalement le parametre config qui contien le type de donnée a etre envoyées dans notre cas type json
    const { data } = await axios.post(
      //uri:adresse dynamic en place de:http://192.168.1.30
      `${uri}/api/commandes`,

      commande,

      config
    );
    //le dispatch se fait vers le reduser car il s'agit d'un type
    await dispatch({ type: COMMANDE_CREER_SUCCES, payload: data });

    await dispatch({ type: CHARIOT_RESET });

    alert("Commande est enregistrée avec succés!");
  } catch (error) {
    dispatch({
      type: COMMANDE_CREER_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};

export const mesCommandesListe = () => async (dispatch, getState) => {
  try {
    //extract id de client a partir
    const {
      client: { client },
    } = getState();

    //
    const config = {
      headers: {
        Authorization: `Bearer ${client.token}`,
      },
    };

    const { data } = await axios.get(
      `${uri}/api/commandes/client/mescommandes/${client._id}`,

      config
    );

    dispatch({ type: COMMANDE_LISTE_CLI_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: COMMANDE_LISTE_CLI_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};

export const commandeDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: COMMANDE_DETAILS_REQUETTE });

    const { data } = await axios.get(`${uri}/api/commandes/${id}`);
    dispatch({ type: COMMANDE_DETAILS_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: COMMANDE_DETAILS_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};
//action des commande par date et par représentant
export const commandesPardaterep =
  (date_d, date_f, cod_rep) => async (dispatch, getState) => {
    try {
      dispatch({ type: COMMANDE_LISTE_REP_REQUETTE });
      const {
        client: { client },
        clientsListeState: { clients },
      } = getState();

      const { data } =
        client.nivcli_cloud == "R" && cod_rep == "tousF"
          ? await axios.get(
              `${uri}/api/commandes/cmdByDateAll/${date_d}/${date_f}`
            )
          : client.nivcli_cloud == "R" && cod_rep == "tous"
          ? await axios.get(
              `${uri}/api/commandes/cmdByDateAll/${date_d}/${date_f}`
            )
          : client.nivcli_cloud == "F"
          ? await axios.get(
              `${uri}/api/commandes/cmdByDate/${date_d}/${date_f}/${client.cod_cli}`
            )
          : cod_rep == "tous"
          ? await axios.get(
              `${uri}/api/commandes/cmdByDateAll/${date_d}/${date_f}`
            )
          : await axios.get(
              `${uri}/api/commandes/cmdByDaterep/${date_d}/${date_f}/${cod_rep}`
            );
      if (client.nivcli_cloud == "R" && cod_rep == "tous") {
        const dt = data.filter(
          (comm) =>
            (comm.cod_rep === client.cod_cli &&
              clients.find((c) => comm.cod_cli == c.cod_cli).cod_rep ==
                client.cod_cli) ||
            (comm?.cod_rep == null &&
              clients.find((c) => comm.cod_cli == c.cod_cli).cod_rep ==
                client.cod_cli)
        );
        dispatch({ type: COMMANDE_LISTE_REP_SUCCES, payload: dt });
      } else if (client.nivcli_cloud == "R" && cod_rep == "tousF") {
        const dt = data.filter(
          (comm) =>
            comm?.cod_rep == null &&
            clients.find((c) => comm.cod_cli == c.cod_cli).cod_rep ==
              client.cod_cli
        );
        dispatch({ type: COMMANDE_LISTE_REP_SUCCES, payload: dt });
      } else {
        dispatch({ type: COMMANDE_LISTE_REP_SUCCES, payload: data });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: COMMANDE_LISTE_REP_ECHEC,
        payload: error.response && error.response.data.message,
      });
    }
  };
//fin action par date et par représentant

export const commandesListeParCode =
  (date_d, date_f, cod_cli) => async (dispatch) => {
    try {
      const { data } = await axios.get(
        `${uri}/api/commandes/cmdByDate/${date_d}/${date_f}/${cod_cli}`
      );

      dispatch({ type: COMMANDE_LISTE_CODE_SUCCES, payload: data });
    } catch (error) {
      dispatch({
        type: COMMANDE_LISTE_CODE_ECHEC,
        payload: error.response && error.response.data.message,
      });
    }
  };
//tant que nous somme au niveau action alors pour faire recupéré des valeur apartir de state on utilisae getstate l'equivalant de useselecter
export const commandeFiltre = (crit) => (dispatch, getState) => {
  const {
    //commandesListeCode le variable qui existe dans le state recupérer avec la fonction getstate
    commandesListeCode: { commandes: cmd },
    //commandes: cmd c'est un alias pour commandes pour eviter l'ombiguité
  } = getState();
  let commF = [];
  //if crit ="Remis" then map dans les données qui sont dans le variable cmd et a chaque ligne on test si  comm.cmd_remis =true alors on charge le table
  crit == "Remis"
    ? cmd.map((comm) => comm.cmd_remis == true && commF.push(comm))
    : //else is crit = autre valeur alors map dans comm et faire le necessaire  et
      cmd.map((comm) => comm.isLivree == true && commF.push(comm));
  // aprés on fait le dispatch de tableau déja alimenter ,le dispatch fait l'actualisation de state avec des nouveau données
  //le dispatch est toujour vers le reducer cette fois le payload est un tableau
  //le payload cette fois est une donnée filtré
  dispatch({ type: COMMANDE_LISTE_CODE_SUCCES, payload: commF });
};

export const commandesTous = (deb, fin, rep) => async (dispatch) => {
  dispatch({ type: COMMANDE_TOUS_REQUETTE });
  try {
    const { data } = await axios.get(
      `${uri}/api/commandes/totcmd/${deb}/${fin}/${rep}`
    );

    dispatch({ type: COMMANDE_TOUS_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: COMMANDE_TOUS_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};

export const rapportArtVente = (deb, fin, limit) => async (dispatch) => {
  dispatch({ type: VENTE_RAPPORT_REQUETTE });
  try {
    const { data } = await axios.get(
      `${uri}/api/commandes/rapportVnt/${deb}/${fin}/${limit}`
    );

    dispatch({ type: VENTE_RAPPORT_SUCCES, payload: data });
  } catch (error) {
    dispatch({
      type: VENTE_RAPPORT_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};
